import { Combo } from './combo.model';
import { GerenciamentoCurso } from './gerenciamento-curso.model';
import { TurmaDiaSemana } from './turma-dia-semana';

export class Turma {
    public id: number;
    public turma_titulo: string;
    public data_inicio: Date;
    public data_fim: Date;
    public id_pais: number;
    public id_uf: number;
    public id_cidade: number;
    public id_curso: number;

    public turma_dia_semana: TurmaDiaSemana;
    public curso: GerenciamentoCurso;
}




// WEBPACK FOOTER //
// ./src/app/entity/turma-model.ts